import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/admin/invoices/invoices.component.scss.shim.ngstyle.ts